export const NAV = {
  logo: 'nav-logo-link',
  allBanksLink: 'nav-banks-link',
  compareLink: 'nav-compare-link',
  rankingsLink: 'nav-rankings-link',
  aboutLink: 'nav-about-link',
  partnersLink: 'nav-partners-link',
  ctaButton: 'nav-cta-compare-button',
  mobileMenuToggle: 'nav-mobile-menu-toggle',
};

export const LANDING = {
  heroCompareBtn: 'landing-hero-compare-button',
  heroRankingsBtn: 'landing-hero-rankings-button',
  heroStatBadge: 'landing-hero-stat-badge',
  heroGlobalIndexStatement: 'landing-hero-global-index-statement',
  heroIndependentBadge: 'landing-hero-independent-badge',
  heroPrivateBankShareStat: 'landing-hero-private-bank-share-stat',
  statBanksTracked: 'landing-stat-banks-tracked',
  statPrivateBanks: 'landing-stat-private-banks',
  statCountries: 'landing-stat-countries',
  statRegions: 'landing-stat-regions',
  statWealthHubs: 'landing-stat-wealth-hubs',
  travellerCta: 'landing-traveller-cta-button',
  privateBankingBanner: 'landing-private-banking-banner',
  privateBankingCta: 'landing-private-banking-cta-button',
  b2bBanner: 'landing-b2b-banner',
  b2bBannerCta: 'landing-b2b-banner-cta-button',
  openDataSection: 'landing-open-data-section',
  openDataEnterpriseCta: 'landing-open-data-enterprise-cta',
  searchInput: 'landing-global-search-input',
  searchClearBtn: 'landing-global-search-clear-button',
  searchDropdown: 'landing-global-search-dropdown',
  searchResultItem: 'landing-global-search-result-item',
  searchNoResults: 'landing-global-search-no-results',
  searchViewAllBtn: 'landing-global-search-view-all-button',
  searchSmartSection: 'landing-global-search-smart-section',
  searchSmartSummary: 'landing-global-search-smart-summary',
  searchIntentBanner: 'landing-global-search-intent-banner',
  searchSmartItem: 'landing-global-search-smart-item',
  searchSmartLoading: 'landing-global-search-smart-loading',
  searchSuggestionsSection: 'landing-global-search-suggestions-section',
  searchSuggestionItem: 'landing-global-search-suggestion-item',
  globalIndexStatusBar: 'landing-global-index-status-bar',
  usCoverageBanner: 'landing-us-coverage-banner',
};

export const PRIVATE_BANKING = {
  page: 'private-banking-page',
  disclaimer: 'private-banking-disclaimer',
  grid: 'private-banking-grid',
  card: 'private-banking-card',
  visitLink: 'private-banking-visit-link',
  comingSoon: 'private-banking-coming-soon',
  marketSwitch: 'private-banking-market-switch',
  marketOptionPrefix: 'private-banking-market-option',
  compareLink: 'private-banking-compare-link',
  marketUpdatedBadge: 'private-banking-market-updated-badge',
  marketReviewedNotice: 'private-banking-market-reviewed-notice',
  marketAuditedCount: 'private-banking-market-audited-count',
  scopeNote: 'private-banking-scope-note',
};

export const PRIVATE_BANKING_COMPARE = {
  page: 'pb-compare-page',
  searchInput: 'pb-compare-search-input',
  marketSelect: 'pb-compare-market-select',
  grid: 'pb-compare-grid',
  bankCheckbox: 'pb-compare-bank-checkbox',
  table: 'pb-compare-table',
  floatingBar: 'pb-compare-floating-bar',
  selectedCount: 'pb-compare-selected-count',
  clearButton: 'pb-compare-clear-button',
  compareButton: 'pb-compare-compare-button',
  deselectButton: 'pb-compare-deselect-button',
  copyLinkButton: 'pb-compare-copy-link-button',
  lastUpdatedRow: 'pb-compare-last-updated-row',
};

export const COMPARE = {
  searchInput: 'compare-search-input',
  regionSelect: 'compare-region-select',
  grid: 'compare-banks-grid',
  bankCheckbox: 'compare-bank-checkbox',
  floatingBar: 'compare-floating-bar',
  selectedCount: 'compare-selected-count',
  compareButton: 'compare-compare-button',
  lastUpdatedRow: 'compare-last-updated-row',
  clearButton: 'compare-clear-button',
  table: 'compare-comparison-table',
  deselectButton: 'compare-deselect-button',
};

export const RANKINGS = {
  regionTabs: 'rankings-region-tabs',
  table: 'rankings-top10-table',
  shareButton: 'rankings-share-button',
  regionUpdatedBadge: 'rankings-region-updated-badge',
  regionReviewedNotice: 'rankings-region-reviewed-notice',
};

export const CALCULATOR = {
  regionSelect: 'calculator-region-select',
  countrySelect: 'calculator-country-select',
  tripDaysInput: 'calculator-trip-days-input',
  atmAmountInput: 'calculator-atm-amount-input',
  atmCountInput: 'calculator-atm-count-input',
  cardAmountInput: 'calculator-card-amount-input',
  wireCountInput: 'calculator-wire-count-input',
  resultsTable: 'calculator-results-table',
  resultRow: 'calculator-result-row',
  breakdownDialog: 'calculator-breakdown-dialog',
  breakdownTotal: 'calculator-breakdown-total',
  breakdownLineItem: 'calculator-breakdown-line-item',
};

export const ABOUT = {
  missionSection: 'about-mission-section',
  coverageSection: 'about-coverage-section',
  travellerSection: 'about-traveller-section',
  trustSection: 'about-trust-section',
  travellerExampleNote: 'about-traveller-example-note',
};

export const PARTNERS = {
  contactCta: 'partners-contact-cta',
  opportunityAffiliateCpa: 'partners-opportunity-affiliate-cpa',
  opportunitySponsoredListings: 'partners-opportunity-sponsored-listings',
  opportunityDisplayAds: 'partners-opportunity-display-ads',
  opportunityDataLicensing: 'partners-opportunity-data-licensing',
  opportunityResearchReports: 'partners-opportunity-research-reports',
  opportunityWhiteLabel: 'partners-opportunity-white-label',
  globalStandardBanner: 'partners-global-standard-banner',
};

export const BANK_DETAIL = {
  page: 'bank-detail-page',
  backLink: 'bank-detail-back-link',
  categoryCard: 'bank-detail-category-card',
  favoriteButton: 'bank-detail-favorite-button',
  reportIssueButton: 'bank-detail-report-issue-button',
  reportDialog: 'bank-detail-report-dialog',
  reportDescriptionInput: 'bank-detail-report-description-textarea',
  reportEmailInput: 'bank-detail-report-email-input',
  reportSubmitButton: 'bank-detail-report-submit-button',
  lastUpdatedStat: 'bank-detail-last-updated-stat',
  countryRankStat: 'bank-detail-country-rank-stat',
  regionRankStat: 'bank-detail-region-rank-stat',
};

export const SPONSORED_AD = {
  card: 'sponsored-ad-card',
  ctaButton: 'sponsored-ad-cta-button',
};

export const ALL_BANKS = {
  searchInput: 'all-banks-search-input',
  regionSelect: 'all-banks-region-select',
  countrySelect: 'all-banks-country-select',
  grid: 'all-banks-grid',
  card: 'all-banks-card',
  regionUpdatedBadge: 'all-banks-region-updated-badge',
  regionReviewedNotice: 'all-banks-region-reviewed-notice',
  regionAuditedCount: 'all-banks-region-audited-count',
};

export const FOOTER = {
  navLinks: 'footer-nav-links',
  legalLinks: 'footer-legal-links',
  contactLink: 'footer-contact-link',
  disclaimer: 'footer-verify-disclaimer',
  copyright: 'footer-copyright',
  affiliateNote: 'footer-affiliate-note',
};

export const CONTACT = {
  nameInput: 'contact-name-input',
  emailInput: 'contact-email-input',
  messageInput: 'contact-message-textarea',
  submitButton: 'contact-submit-button',
};

export const COOKIE_CONSENT = {
  banner: 'cookie-consent-banner',
  acceptButton: 'cookie-consent-accept-button',
  dismissButton: 'cookie-consent-dismiss-button',
  policyLink: 'cookie-consent-policy-link',
};

export const ADMIN = {
  emailInput: 'admin-login-email-input',
  passwordInput: 'admin-login-password-input',
  loginButton: 'admin-login-submit-button',
  loginError: 'admin-login-error',
  logoutButton: 'admin-logout-button',
  contactList: 'admin-contact-messages-list',
  leadsList: 'admin-partner-leads-list',
  reportsList: 'admin-data-reports-list',
  markReadMessagePrefix: 'admin-mark-read-message',
  markReadLeadPrefix: 'admin-mark-read-lead',
  markReadReportPrefix: 'admin-mark-read-report',
};

export const PB_COST_EXAMPLE = {
  section: 'pb-cost-example-section',
  disclaimerBanner: 'pb-cost-example-disclaimer',
  methodologyNote: 'pb-cost-example-methodology-note',
  bankCardPrefix: 'pb-cost-example-bank-card',
  retailTotalPrefix: 'pb-cost-example-retail-total',
  pbTotalPrefix: 'pb-cost-example-pb-total',
  compareCta: 'pb-cost-example-compare-cta',
  portfolioToggle: 'pb-cost-example-portfolio-toggle',
  portfolioOptionPrefix: 'pb-cost-example-portfolio-option',
  feesAsOfNote: 'pb-cost-example-fees-as-of-note',
  scopeNote: 'pb-cost-example-scope-note',
};

export const SWITCH_SAVE = {
  regionSelect: 'switch-save-region-select',
  monthlyFeeSlider: 'switch-save-monthly-fee-slider',
  transfersSlider: 'switch-save-transfers-slider',
  avgFeeSlider: 'switch-save-avg-fee-slider',
  yearlySavings: 'switch-save-yearly-savings',
};
